import {
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useLayoutEffect,
  useRef,
} from "react";
import { useWindowSize } from "@fwa/src/hooks/useWindowSize";

export const HomePageImpactStatement = ({
  number,
  children,
  setStatementPositions,
}: {
  number: number;
  children?: ReactNode;
  setStatementPositions?: Dispatch<
    SetStateAction<{ number: number; top: number; bottom: number }[]>
  >;
}) => {
  const statementRef = useRef<HTMLDivElement>(null);
  const windowSize = useWindowSize();

  useLayoutEffect(() => {
    if (
      statementRef.current &&
      setStatementPositions &&
      typeof window !== "undefined"
    ) {
      setStatementPositions((prevPositions) => {
        const rect = statementRef.current!.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        const bottom = rect.bottom + window.scrollY;
        const otherPositions = prevPositions.filter(
          (pos) => pos.number !== number,
        );
        return [...otherPositions, { number, top, bottom }];
      });
    }
  }, [number, setStatementPositions, windowSize]);

  return (
    <div ref={statementRef} style={{ minHeight: "4px" }}>
      {children}
    </div>
  );
};

export default HomePageImpactStatement;
